import {ActionsTransform} from "./ActionsTransform";
import {assistantsTransform} from "../assistants/AssistantsTransform";

import {
  IVRCreateModel,
  IVRListModel,
  IVRRecordModel,
  IVRUpdateModel,
} from "@/api/models/actions";
import {PaginatedResponse, IVRAction} from "@/api/services";
import {BaseAction} from "@/types/api";

export class ActionIVRTransform extends ActionsTransform<
  IVRRecordModel,
  IVRCreateModel,
  IVRUpdateModel
> {
  public makeRecordModel(dto: IVRAction & BaseAction): IVRRecordModel {
    const model: IVRRecordModel = {
      ...dto,
      title: dto.name,
      description: dto.goal,
      assistants: dto.assistants.map(assistant =>
        assistantsTransform.makeEvenCompactModel(assistant),
      ),
      icon: dto.icon,
    };
    return model;
  }

  public makeListModel(dto: PaginatedResponse): IVRListModel {
    const model: IVRListModel = {
      records: dto.items.map(item =>
        this.makeRecordModel(item as IVRAction & BaseAction),
      ),
      pagination: this.makePaginationModel(dto),
    };

    return model;
  }

  public makeCreateDto(model: IVRCreateModel): IVRAction {
    const dto: IVRAction = {
      type: "ivr",
      workspace_id: model.workspaceId,
      name: model.title,
      goal: model.description,
    };

    return dto;
  }

  public makeUpdateDto(model: IVRUpdateModel): IVRAction {
    const dto: IVRAction = {
      type: "ivr",
      workspace_id: model.workspaceId,
      name: model.title,
      goal: model.description,
    };

    return dto;
  }
}

export const actionIVRTransform = new ActionIVRTransform();
